const consent_modal = require('./sk/consent_modal')
const settings_modal  = require('./sk/settings_modal')

module.exports = {
    callLinkName: 'Nastavenie cookies',
    consent_modal,
    settings_modal
}
